
  <div class="details-cmd" id="booking-validation" style="text-align: center" *ngIf="getUser() && !getUser().isPreAccount">
    <div class="container" style="margin-bottom: 20px" *ngIf="!deadLineConfirm">
      <div *ngIf="!event.has_open_ticketing">
        <div class="inline-block">
          <i class="fa fa-check check text-green"></i>
          <h3 class="text-uppercase" *ngIf="result">{{'front_booking_confirm.your_booking'| translate}} <span class="no">{{result.id+' '}}</span>{{'front_booking_confirm.has_been_well_taken_care_of'| translate}}</h3>
          <div *ngIf= "result && result.deadlines.length == 0">
            <h5 class="text-uppercase">{{'front_booking_confirm.your_tickets_are_accessible_in_your_email_and_in_your'| translate}} <a [routerLink]="['/account/']">{{'front_booking_confirm.personnal_space'| translate}}</a></h5>
          </div>
          <div *ngIf="result && result.deadlines.length > 0">
            <h5>Vous recevrez les billets au paiement du dernier échéance</h5>
          </div>
          <br>
          <a *ngIf="!embeded" class="btn-TxtColor" href="/">Retour Agenda</a>
        </div>
      </div>

      <div *ngIf="event.has_open_ticketing">
        <div class="inline-block">
          <i class="fa fa-check check text-green"></i>
          <h3 class="text-uppercase" *ngIf="result"><b>{{'front_booking_confirm.thx_for_participation'| translate}} </b></h3><br><br>
          <h5 class="text-uppercase">{{'front_booking_confirm.your_contribution_for_jackpot'| translate}} <b> {{' '+event.name+ ' '}}</b> {{'front_booking_confirm.has_been_saved'| translate}}</h5>
          <h5>{{'front_booking_confirm.email_has_been_sent_to_you'| translate}}</h5> <br>
          <a class="btn-TxtColor" href="/">Retour Agenda</a>
        </div>
      </div>

    </div>
    <div *ngIf="deadLineConfirm" style="text-align: center;font-size: 22px">
      Votre paiement a été enrégistré
    </div>
  </div>

  <div *ngIf="getUser() && getUser().isPreAccount">
    <div class="text-uppercase text-center">
      <i class="fa fa-check check text-green font-size-150"></i>
      <h5>Votre réservation <span class="no">{{result.id+' '}}</span> a été bien pris en compte.</h5>
      <span *ngIf="result.tickets.length>1"> vos billets on été envoyé par mail</span>
      <span *ngIf="result.tickets.length == 1"> votre billet a été envoyé par mail</span> <br>
      <a class="btn-TxtColor" href="/">Retour Agenda</a>
    </div>
    <div   class="mb-lg-5 container row m-auto mtop-40 backgroung-light-gray padding-25">
      <div class="col-md-8 container margin-bottom-20-mini-768">
        <h3>Créez un compte Akces pour une meilleur expérience.</h3>
        <h5>Dans votre espace personnel vous pourrez:</h5>
        <div class="flex-space-between mt-5 col-md-10">
          <div>
            <div class="circle">
              <img src="../../../../assets/imgs/icons/search.png" height="60" width="60"/>
            </div>
            <div class="center bold">Retrouvez</div>
          </div>
          <div>
            <div class="circle">
              <img src="../../../../assets/imgs/icons/download.png" height="60" width="60"/>
            </div>
            <div class="center bold">Téléchargez</div>
          </div>
          <div>
            <div class="circle">
              <img src="../../../../assets/imgs/icons/edit.png" height="60" width="60"/>
            </div>
            <div class="center bold">Editer</div>
          </div>
          <div>
            <div class="circle">
              <img src="../../../../assets/imgs/icons/Billet.png" height="60" width="60"/>
            </div>
            <div class="center bold">vos billets</div>
          </div>
        </div>
      </div>
      <div class="col-md-4 container">
        <h5 class="mb-2">Créez votre mot de passe</h5>

        <form (ngSubmit)="onSubmit()" #passForm="ngForm">
          <div class="form-group row" [ngClass]="{'has-danger': password.errors && (password.dirty || password.touched || errorMsg)}">
            <div class="col-12 rp-xs">
              <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                <input class="form-control" type="password" value="" id="password" name="password" placeholder="Mot de passe" [(ngModel)]="passwordIntputs.password" #password="ngModel" required>
              </div>
              <div class="form-control-feedback alert alert-danger custom-alert-danger" *ngIf="passwordIntputs.password.length<=0">Champs requis</div>
            </div>
          </div>

          <div class="form-group row" [ngClass]="{'has-danger':  (passwordConfirm.touched && !passwordConfirm.valid) || errorMsg }">
            <div class="col-12 rp-xs">
              <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                <input class="form-control"  type="password" value="" id="passwordConfirm" name="passwordConfirm" placeholder="Confirmation de mot de passe" [(ngModel)]="passwordIntputs.passwordConfirm"  #passwordConfirm="ngModel"  required>
              </div>
              <div class="form-control-feedback alert alert-danger custom-alert-danger" *ngIf="passwordIntputs.passwordConfirm.length<=0">champs requis</div>
              <div class="alert-danger custom-alert-danger" *ngIf="passwordIntputs.passwordConfirm != passwordIntputs.password && passwordIntputs.passwordConfirm.length >0 && passwordIntputs.passwordConfirm.length >0">Non conforme</div>
            </div>
          </div>
          <!-- submit button -->
          <div class="form-group row">
            <div class="offset-sm-1 rp-xs col-sm-10 text-center">
              <button type="submit" class="btn btn-primary btn-lg" [disabled]="!passForm.form.valid">Valider</button>
            </div>
          </div>
        </form>

      </div>
    </div>
  </div>

<div></div>




